// This file is automatically generated by /scripts/git-version.ts
export const versions = {
  version: '0.0.0',
  revision: '5610fc3d008b1ca471473d5108f267e2a4d9f81a',
  branch: 'master',
};
